import $ from "jquery";
import moment from "moment";
import "eonasdan-bootstrap-datetimepicker";
import Seed from "DMS/Seed/All";
/**
 * Function to hide and display panel
 * @param {string} id Element's id
 * @param {boolean} hasToBeFast Determine if the hide has to be
 * instant or with an animation
 */
export function editPanel(id, hasToBeFast) {
    if (!hasToBeFast && hasToBeFast !== 'undefined') {
        Seed.Tab.GetFrame().find('[id^=listSearch]').hide();
        var toShow = 'div#toShow' + id;
        Seed.Tab.GetFrame()
            .find('[id^=toFade]')
            .hide('slow', function () {
            $(toShow).show('slow');
        });
    }
    else if (hasToBeFast) {
        var nthChild = id + 1;
        var backId = Seed.Tab.GetFrame()
            .find('#panel-group')
            .children(':nth-child(' + nthChild + ')')
            .attr("id");
        Seed.Tab.GetFrame()
            .find('[id^=toFade]')
            .hide(100, function () {
            $('#' + backId).css('display', 'inherit');
        });
    }
}
/**
 *  Function to move the 'chevron' when the panel's footer
 *   is open or close
 */
export function moveArrow() {
    Seed.Tab.GetFrame().find('.last-row').each(function () {
        $(this).on('click', function () {
            var row = $(this);
            var parent = $(this).parent();
            var grandParent = parent.parent();
            if (parent.hasClass('panel-body')) {
                $(this).detach();
                grandParent.children('.panel-footer').append(row);
                $(this).css('transform', 'rotate(' + 180 + 'deg)');
            }
            else if (parent.hasClass('panel-footer')) {
                $(this).detach();
                grandParent.children('.panel-body').append(row);
                $(this).css('transform', 'rotate(' + 0 + 'deg)');
            }
        });
    });
    Seed.Planning.formatData();
}
/**
 * DatePicker Function..
 */
export function datePicker() {
    var pTarget = Seed.Tab.GetFrame();
    pTarget.find('.globalFormDiv .SM-datepicker')
        .parent()
        .find('button')
        .click(function (event) {
        $(this).parent().parent()
            .find('input')
            .data('DateTimePicker').show();
    });
    pTarget.find('.globalFormDiv .SM-datetimepicker')
        .parent()
        .find('button')
        .click(function (event) {
        $(this).parent().parent()
            .find('input')
            .data('DateTimePicker').show();
    });
    pTarget.find('.globalFormDiv .SM-timepicker').parent()
        .find('button')
        .click(function (event) {
        $(this).parent().parent()
            .find('input')
            .data('DateTimePicker').show();
    });
    // Date
    $(pTarget).find(".globalFormDiv .SM-datepicker").datetimepicker({
        locale: moment.locale(),
        icons: {
            time: 'fa fa-clock-o',
            date: 'fa fa-calendar-o',
            up: 'fa fa-arrow-up',
            down: 'fa fa-arrow-down',
            previous: 'fa fa-angle-left',
            next: 'fa fa-angle-right',
            today: 'fa fa-crosshairs',
            clear: 'fa fa-trash'
        },
        showTodayButton: true,
        showClear: true,
        format: "L",
        useCurrent: false
    });
    // DateHeure
    $(pTarget).find(".globalFormDiv .SM-datetimepicker").datetimepicker({
        locale: moment.locale(),
        icons: {
            time: 'fa fa-clock-o',
            date: 'fa fa-calendar-o',
            up: 'fa fa-arrow-up',
            down: 'fa fa-arrow-down',
            previous: 'fa fa-angle-left',
            next: 'fa fa-angle-right',
            today: 'fa fa-crosshairs',
            clear: 'fa fa-trash'
        },
        showTodayButton: true,
        showClear: true,
        format: "L LT",
        useCurrent: false
    });
    // Heure
    $(pTarget).find(".globalFormDiv .SM-timepicker").datetimepicker({
        locale: moment.locale(),
        icons: {
            time: 'fa fa-clock-o',
            date: 'fa fa-calendar-o',
            up: 'fa fa-arrow-up',
            down: 'fa fa-arrow-down',
            previous: 'fa fa-angle-left',
            next: 'fa fa-angle-right',
            today: 'fa fa-crosshairs',
            clear: 'fa fa-trash'
        },
        format: "LT",
        useCurrent: false
    });
    $(pTarget).find(".globalFormDiv .SM-timepicker").on("dp.hide", function (e) {
        pTarget.onchangeDate = $(this)[0].attributes["data-onchange"].value;
        eval(pTarget.onchangeDate);
        pTarget.onchangeDate = undefined;
    });
    $(pTarget).find(".globalFormDiv .SM-datepicker").on("dp.hide", function (e) {
        pTarget.onchangeDate = $(this)[0].attributes["data-onchange"].value;
        eval(pTarget.onchangeDate);
        pTarget.onchangeDate = undefined;
    });
    $(pTarget).find(".globalFormDiv .SM-datetimepicker").on("dp.hide", function (e) {
        pTarget.onchangeDate = $(this)[0].attributes["data-onchange"].value;
        eval(pTarget.onchangeDate);
        pTarget.onchangeDate = undefined;
    });
}
/**
 * Function to hide the buttonBar div. Activated only when
 *   there's no button inside this div
 */
export function hideButtonBar() {
    var btnBar = Seed.Tab.GetFrame().find('.buttonBar');
    if (btnBar.children().length === 0)
        $(btnBar).remove();
}
export function getOffset() {
    Seed.Tab.GetElementInFrame(Seed.Tab.GetOffset());
}
export function setDates(values) {
    if (values !== null && typeof values === 'object') {
        for (var i = 0; i < values.length; i++) {
            for (var key in values[i]) {
                var data = $("#" + key).data("DateTimePicker");
                if (typeof data !== "undefined") {
                    data.date(moment(values[i][key]));
                }
            }
        }
    }
}
//# sourceMappingURL=smartController.js.map